<div
	class="absolute inset-0 sm:static lg:static flex flex-col h-full transition-transform duration-400 ease-drawer bg-card"
	[ngClass]="{
		'flex flex-col flex-1 w-full sm:w-96 lg:w-96 shadow': isOpen(),
		'hidden w-0': !isOpen()
	}"
	*minimumTier="'Enterprise'"
>
	<!-- Header -->
	<div
		class="ai-chat-header flex flex-0 items-center justify-start cursor-pointer"
		(click)="toggle()"
	>
		<div class="flex flex-auto items-center justify-center">
			<div class="flex flex-0 items-center justify-center w-16">
				<img
					class="w-10 scale-110"
					src="assets/images/logo/logo-bird.svg"
					alt="Claim Mosaic"
				/>
			</div>
			<div class="text-lg font-medium text-secondary">Mosaic AI</div>
			<button class="ml-auto mr-4" mat-icon-button>
				<mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
			</button>
		</div>
	</div>

	<!-- Content -->
	<div class="flex flex-auto border-t overflow-hidden">
		<!-- Conversation -->
		<div
			class="flex flex-col flex-auto border-l overflow-hidden bg-gray-50 dark:bg-transparent"
		>
			<div
				class="flex flex-col-reverse overflow-y-auto overscroll-y-contain flex-1"
				#chatContainer
			>
				<div class="flex flex-col flex-auto shrink p-6">
					@for (message of messages; track message.id; let i = $index;
					let first = $first; let last = $last) {
					<div
						class="flex flex-col"
						[ngClass]="{
							'items-end': message.role === messageRoles.User,
							'items-start':
								message.role === messageRoles.Assistant,
							'mt-0.5':
								i > 0 && messages[i - 1].role === message.role,
							'mt-3':
								i > 0 && messages[i - 1].role !== message.role
						}"
					>
						<!-- Bubble -->
						<div
							class="relative w-[calc(100%-1rem)] px-3 py-2 rounded-lg"
							[ngClass]="{
								'bg-blue-500 text-blue-50':
									message.role === messageRoles.User,
								'bg-gray-500 text-gray-50':
									message.role === messageRoles.Assistant
							}"
						>
							<!-- Speech bubble tail -->
							@if (last || messages[i + 1].role !== message.role )
							{
							<div
								class="absolute bottom-0 w-3"
								[ngClass]="{
									'text-blue-500 -right-1 -mr-px mb-px':
										message.role === messageRoles.User,
									'text-gray-500 -left-1 -ml-px mb-px -scale-x-1':
										message.role === messageRoles.Assistant
								}"
							>
								<ng-container
									*ngTemplateOutlet="speechBubbleExtension"
								></ng-container>
							</div>
							}

							<!-- Message -->
							<div class="min-w-4 leading-5 overflow-x-auto">
								<div (click)="handleClick($event)">
									<markdown
										[data]="message.content"
									></markdown>
								</div>

								@if (message.actionType === actionType.ViewClaim
								&& message.ids.length == 1) {
								<button
									type="button"
									class="rounded mt-2 bg-orange-50 px-2 py-1 text-xs font-semibold text-orange-600 shadow-sm hover:bg-orange-100"
									(click)="
										openDetail(message.ids[0].toString())
									"
								>
									View Claims
								</button>
								}
							</div>
						</div>
					</div>
					}
				</div>
			</div>

			<!-- Message field -->
			<div
				class="flex items-end p-4 border-t gap-2 bg-gray-50 dark:bg-transparent"
			>
				<div class="flex items-center h-11 my-px">
					<button
						mat-icon-button
						(click)="onNewChat()"
						[matTooltip]="'Start New Chat'"
					>
						<i class="material-icons text-xl">&#xe266;</i>
					</button>
				</div>

				<mat-form-field
					class="fuse-mat-dense fuse-mat-rounded fuse-mat-bold w-full"
					[subscriptSizing]="'dynamic'"
				>
					<input
						[(ngModel)]="message"
						matInput
						#messageInput
						placeholder="Type your message"
						(keydown.enter)="sendMessage()"
					/>
				</mat-form-field>

				<div class="flex items-center h-11 my-px">
					<button mat-icon-button (click)="sendMessage()">
						<mat-icon
							[svgIcon]="'heroicons_outline:paper-airplane'"
						></mat-icon>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Select chat or start new template -->
<!-- Speech bubble tail SVG -->
<!-- @formatter:off -->
<ng-template #speechBubbleExtension>
	<svg
		width="100%"
		height="100%"
		viewBox="0 0 66 66"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g
			id="Page-1"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<path
				d="M1.01522827,0.516204834 C-8.83532715,54.3062744 61.7609863,70.5215302 64.8009949,64.3061218 C68.8074951,54.8859711 30.1663208,52.9997559 37.5036011,0.516204834 L1.01522827,0.516204834 Z"
				fill="currentColor"
				fill-rule="nonzero"
			></path>
		</g>
	</svg>
</ng-template>
<!-- @formatter:on -->
